import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class CancelFormVersionInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService: IFormTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formTypeCode: string) {
    await this.formTypeService.cancelFormVersion(formTypeCode);
  }
}
